<template>
  <div>
    <es-loader
      v-if="loading"
      style="margin: 1rem"
    />
    <es-exception
      v-else-if="loadingError"
      exceptionMessage="Batch not found."
    />
    <div v-else>
      <div>
        <es-profile-header>
          <template #profile-header>
            <div class="columns">
              <div class="column">
                <div class="column-content">
                  <div class="header-title">
                    Batch Profile
                  </div>
                  <div class="header-subtitle">
                    Contains one or many records.
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template #profile-overview>
            <div class="columns">
              <div class="column">
                <div class="column-content">
                  <div class="column-title">
                    {{ batch.profileHeader.id }}
                  </div>
                  <div class="column-subtitle">
                    Batch ID
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="column-content">
                  <div class="column-title">
                    <div>
                      {{ batch.profileHeader.submissionType }}
                    </div>
                    <div
                      v-if="batch.profileHeader.submissionType === 'File'"
                      class="max-width" style="margin: auto"
                    >
                      ({{ batch.profileHeader.fileName }})
                    </div>
                  </div>
                  <div class="column-subtitle">
                    Submission Type
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="column-content">
                  <div class="column-title">
                    {{ batch.profileHeader.processInfo | formatDateMMDDYYYYHHMM }}
                  </div>
                  <div class="column-subtitle">
                    Process Info
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="column-content">
                  <div class="status-box" style="width: fit-content; margin: auto;">
                    <dm-status-info-icon
                      :batchStatus="batch.status"
                    />
                  </div>
                <div class="column-subtitle">
                  Status
                </div>
              </div>
            </div>
          </div>
        </template>
        </es-profile-header>
        <div class="tabs-container">
          <div class="tabs no-bottom-border">
            <ul>
              <li v-if="hasModule('DRMCH:MATCH:HISTORY:VIEW')"
                :class="{ 'is-active': this.$route.name === 'DMBatchInfoDetails' }"
              >
                <router-link replace
                  :to="{ name: 'DMBatchInfoDetails' }"
                  >
                  DETAILS
                </router-link>
              </li>
              <li v-if="hasModule('DRMCH:DWNLD:DOWNLOAD')"
                :class="{ 'is-active': this.$route.name === 'DMBatchInfoDownload' }">
                <router-link replace
                  :to="{ name: 'DMBatchInfoDownload' }"
                >
                  DOWNLOAD
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <router-view :batch="batch"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleLeft,
} from '@fortawesome/pro-regular-svg-icons';
import DmStatusInfoIcon from '@/components/DmStatusInfoIcon.vue';
import EsException from '@/components/EsException.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsProfileHeader from '@/components/EsProfileHeader.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import PermissionManager from '@/mixins/PermissionManager';

library.add(
  faAngleDoubleLeft,
);

export default {
  mixins: [
    BreadcrumbsManager,
    PermissionManager,
  ],
  components: {
    DmStatusInfoIcon,
    EsException,
    EsLoader,
    EsProfileHeader,
  },
  props: [
    'batchId',
  ],
  data() {
    return {
      batch: null,
      loading: true,
      loadingError: null,
    };
  },
  created() {
    this.loadBatch();
  },
  mounted() {
    this.setBreadcrumbs();
  },
  computed: {
    ...mapGetters([
      'hasProgramPermission',
    ]),
  },
  methods: {
    setBreadcrumbs() {
      this.setBreadcrumb([
        { text: 'Home', to: { name: 'directMatch' } },
        { text: 'Processing Information ', to: {} },
      ]);
    },
    async loadBatch() {
      try {
        this.loading = true;
        const res = await axios.get(`directmatch/batches/${this.batchId}?stats=true`);
        this.batch = res.data;
      } catch (error) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

  <style lang="sass" scoped>
    .margin-bottom
      margin-bottom: 1rem
    .progress-bar
      height: 5px
      width: 75px
      margin-bottom: 3px
      margin-left: 1rem
    .max-width
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis
      max-width: 20ch
  </style>
